// extracted by mini-css-extract-plugin
export default {"title":"Recommend_title__kBlV0","ContainerJointShopping":"Recommend_ContainerJointShopping__nfXwT"};